import { getActionTypes } from './get-actions';
import { isSubscribed } from '../../../preact/utils/newsletters-utils';

export const getReducer = (actionPrefix) => (action) => ({
  // START
  [getActionTypes(actionPrefix).FETCH_START]: () => ({
    isWidgetLoading: true,
  }),
  [getActionTypes(actionPrefix).UPDATE_START]: () => ({
    isWidgetLoading: true,
    isUpdating: true,
  }),

  // SUCCESS
  [getActionTypes(actionPrefix).FETCH_SUCCESS]: () => ({
    newsletters: action.payload.data,
    selectedOptionsIds: action.payload.data
      ?.filter((newsletter) => isSubscribed(newsletter.status))
      .map((newsletter) => newsletter.id),
    error: false,
    isWidgetLoading: false,
  }),
  [getActionTypes(actionPrefix).UPDATE_SUCCESS]: () => ({
    newsletters: action.payload.data,
    error: false,
    isUpdating: false,
    isWidgetLoading: false,
  }),

  // FAILURE
  [getActionTypes(actionPrefix).FETCH_FAILURE]: () => ({
    error: {
      status: action.payload.error?.status,
      code: action.payload.error?.code,
      message: action.payload.error?.message,
    },
    isWidgetLoading: false,
  }),
  [getActionTypes(actionPrefix).UPDATE_FAILURE]: (state) => ({
    error: {
      status: action.payload.error?.status,
      code: action.payload.error?.code,
      message: action.payload.error?.message,
    },
    isUpdating: false,
    isWidgetLoading: false,
    selectedOptionsIds: state.newsletters
      .filter((newsletter) => isSubscribed(newsletter.status))
      .map((newsletter) => newsletter.id),
  }),

  // USER INTERACTION
  [getActionTypes(actionPrefix).SELECT_OPTIONS]: () => ({
    selectedOptionsIds: action.payload.options,
  }),
});
